/* ============================================================
   KOTAK "TIKTOK CHECKS" — Control Panel (2026-10-13)

   Dua suis: Music copyright check + Content check lite. Pelanggan memilih
   sama ada robot menghidupkan atau mematikan suis yang sama pada halaman
   upload TikTok. LALAI HIDUP (keputusan user).

   Nilai + simpanan: utils/semakanTiktok.js (per-browser). Ditulis HANYA
   dalam pengendali klik — bukan effect (perangkap mount / StrictMode).
   Baris suis dilukis oleh `barisSuis` = `barisSuisV39` App.jsx supaya rupa
   suis kekal SATU takrifan. Nama suis KEKAL English — sama seperti yang
   pelanggan lihat di TikTok.
   ============================================================ */
import { useState } from 'react';
import { bacaSemakanTiktok, tulisSemakanTiktok } from '../utils/semakanTiktok';

export default function SemakanTiktokV39({ t, barisSuis }) {
  const [nilai, setNilai] = useState(() => bacaSemakanTiktok());
  const [gagalSimpan, setGagalSimpan] = useState(false);

  const tukar = (jenis) => {
    const baru = !nilai[jenis];
    setNilai((n) => ({ ...n, [jenis]: baru }));
    /* Storan browser ditutup → pilihan tidak akan sampai ke robot. Beritahu, jangan senyap. */
    setGagalSimpan(!tulisSemakanTiktok(jenis, baru));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 15, paddingBottom: 16, borderBottom: '1px solid var(--s-line)', marginBottom: 16 }}>
      <p className="s-sect__title">{t('workspace.page.sect.ttChecks', 'TikTok Checks')}</p>
      {barisSuis({
        kunci: 'ttsemakmuzik', label: 'Music copyright check',
        nota: nilai.muzik
          ? t('workspace.ttChecks.muzikOn', 'Robot menghidupkan Music copyright check di TikTok untuk setiap video.')
          : t('workspace.ttChecks.muzikOff', 'Robot mematikan Music copyright check di TikTok. Lagu dalam video tidak disemak.'),
        on: nilai.muzik, onChange: () => tukar('muzik'),
      })}
      {barisSuis({
        kunci: 'ttsemakkandungan', label: 'Content check lite',
        nota: nilai.kandungan
          ? t('workspace.ttChecks.kandunganOn', 'Robot menunggu TikTok selesai Checking sebelum Post / Schedule. Jika tidak selesai, video disimpan sebagai draf.')
          : t('workspace.ttChecks.kandunganOff', 'Robot mematikan Content check lite dan terus Post / Schedule. Amaran kandungan TikTok tidak akan dikesan.'),
        on: nilai.kandungan, onChange: () => tukar('kandungan'),
      })}
      {gagalSimpan && (
        <p className="s-hint" role="alert">{t('workspace.ttChecks.gagalSimpan', 'Pilihan ini tidak dapat disimpan dalam browser ini.')}</p>
      )}
    </div>
  );
}
